import createCaseFirst from './_createCaseFirst.js';

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

export default upperFirst;



//////////////////
// WEBPACK FOOTER
// ./~/lodash-es/upperFirst.js
// module id = 281
// module chunks = 41